import * as React from 'react';
import { Overlay, SideModal, SideModalContent } from '~/common/layout/Modals';
import Head from '~/common/layout/Head';

import PaycodeForm from './PaycodeForm';

export default (props) => {
  const { headTitle, onClose, onSubmit, paycode, errorMessage, ...rest } = props;

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <Overlay onClick={handleClose}>
      <SideModal>
        <Head headTitle={headTitle} />

        <SideModalContent>
          <PaycodeForm
            onSubmit={onSubmit}
            initialValues={paycode}
            error={errorMessage}
            {...rest}
          />
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};
